import { f as i, g as s } from "./funFacts-4c7657d3.js";
const e = [
  "Please wait while we train our hamsters to power up the servers.",
  "Hold on tight while we summon the Internet gnomes to fetch your data.",
  "Loading awesomeness... It's taking a bit longer because we're adding extra sparkles.",
  "Counting to infinity... This might take a while.",
  "Making things magically appear... Abracadabra!",
  "Loading unicorns... It's a delicate process, but totally worth it.",
  "Hang in there! Our team of monkeys is working hard to fetch your content.",
  "Loading... Just imagine a dancing penguin to keep you entertained.",
  "Patience, young Jedi! The Force is strong with this loading screen.",
  "Summoning intergalactic spaceships to bring you the requested content."
];
function n() {
  const t = Math.floor(Math.random() * e.length);
  return e[t];
}
export {
  i as funFacts,
  s as getFunFacts,
  n as getLoadingMessage,
  e as loadingMessages
};
